import Calc from '../modules/calc';

class Counter extends Calc {
    constructor() {
        super();
        this.plusButtons = document.querySelectorAll('.button-plus');
        this.minusButtons = document.querySelectorAll('.button-minus');

        this.wireinput = document.getElementById('wire_length');
        this.auxinput = document.getElementById('aux_wire_length');
        

        this.eventsCounter();
    }

    eventsCounter() {
    //Prevent default on input fields
        this.wireinput.onkeydown = (e) => {
            if (e.which === 13) {
                e.preventDefault();
                super.calculate();
              }
        }
    //Prevent default on input fields
        this.auxinput.onkeydown = (e) => {
            if (e.which === 13) {
                e.preventDefault();
                super.calculate();
              }
        }

        this.plusButtons.forEach(el => {
            el.onclick = (e) => {
                this.incrementValue(e);
                super.calculate();
            }
        })

        this.minusButtons.forEach(el => {
            el.onclick = (e) => {
                this.decrementValue(e);
                super.calculate();
            }
        })
    }



    getFields(e) {
    let fieldName = jQuery(e.target).data('field');
    let parent = jQuery(e.target).closest('div');
    let currentVal = parseInt(parent.find('input[name=' + fieldName + ']').val(), 10);

    return [fieldName, parent, currentVal];

    }



//Increment value
  incrementValue(e) {

    let fields = this.getFields(e);
  
    if (!isNaN(fields[2])) {
        fields[1].find('input[name=' + fields[0] + ']').val(fields[2] + 1);
    } else {
        fields[1].find('input[name=' + fields[0] + ']').val(0);
    }
  }

  //Decrement value
  decrementValue(e) {

    let fields = this.getFields(e);

    if(fields[2] <= 4) {
        return
      }
  
    if (!isNaN(fields[2]) && fields[2] > 0) {
        fields[1].find('input[name=' + fields[0] + ']').val(fields[2] - 1);
    } else {
        fields[1].find('input[name=' + fields[0] + ']').val(0);
    }
  }
}

export default Counter;